module.exports = __webpack_public_path__ + "static/media/i_pad_pro@3x.b1d8e986.png";